export default __webpack_public_path__ + "static/brand-10-8b47aba8dc09995299eca4a483c3679b.png";